"use client"

import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { ChevronDown } from "@/lib/icons"
import { YANDERE_ORDERS, isYandereOrder, type YandereOrder } from "@/lib/yandere-filter-terms"
import { useTranslations } from "next-intl"

interface YandereFilterTabsProps {
  value: YandereOrder | null
  onChange: (value: YandereOrder | null) => void
}

const NEWEST = "newest"

// Yande.re's best-of windows (its Popular page, as a search so tags and paging keep working). One dropdown that highlights like an
// active pill once something other than the default newest-first feed is picked.
export function YandereFilterTabs({ value, onChange }: YandereFilterTabsProps) {
  const t = useTranslations("yandereFilterTabs")

  return (
    <div className={SOURCE_FILTER_ROW}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={`${sourceFilterPill(value !== null)} inline-flex items-center gap-1`}>
            {t("order")}: {value ? t(value) : t("newest")}
            <ChevronDown className="h-3 w-3" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[11rem]">
          <DropdownMenuRadioGroup
            value={value ?? NEWEST}
            onValueChange={(next) => onChange(isYandereOrder(next) ? next : null)}
          >
            <DropdownMenuRadioItem value={NEWEST}>{t("newest")}</DropdownMenuRadioItem>
            {YANDERE_ORDERS.map((item) => (
              <DropdownMenuRadioItem key={item.value} value={item.value}>
                {t(item.value)}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
